module.exports = __webpack_public_path__ + "static/media/Rein_Illustratie-01.b5f0193e.svg";